<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header p-2">
          <h6 class="modal-title">{{$t('Modify TTL')}}({{$t('Time to live')}})</h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog">
            <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
          </button>
        </div>
        <div class="modal-body">
          <div>
          <div class="d-inline-flex w-25">
            <input type="radio" value="by_days" v-model="rangeStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Days')}}</label>
          </div>
          <div class="d-inline-flex w-25">
            <input type="radio" value="by_date_wise" v-model="rangeStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="file type"/>
            <label style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Date')}}</label>
          </div>
          </div>
          <div v-if="rangeStrategy == 'by_days'" style="margin-top:8px;">
            <input type="number" @keyup.enter="modifyTTLAction()" ref="folderNameField" v-if="show" class="bg-transparent border rounded text-light form-control input-fields" v-model="TTLValue">
            <div class="config-desc mt-1">{{$t('Days')}}</div>
          </div>
          <div v-else-if="rangeStrategy == 'by_date_wise'" style="display:inline-grid;width:100%;margin-top:8px;">
            <date-picker
              v-model="selectedDate"
              valueType="format"
              placeholder="ex: yyyy-mm-dd"
              class="text-light comm-input-field-style"
              style="padding: 0px;border-radius: 5px;position:relative;top:6px">
            </date-picker>
            <div class="config-desc mt-2">{{$t('Date')}}</div>
          </div>
        </div>
        <div class="modal-footer primary-btn-style">
          <button @click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">{{$t('Cancel')}}</button>
        <button class="btn btn-outline-primary ml-1" @click="modifyTTLAction()">
          {{$t('Save')}}
      </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import DatePicker from "vue2-datepicker";
import Utils from "../../components.utils.js";
import cancelIcon from "../core/InlineCancelField.vue"

export default {
  props:["context", "filesInfo"],
  data: () => ({
    dialog: true,
    TTLValue:null,
    selectedFileInfo:null,
    show:false,
    extension:"",
    rangeStrategy:'by_days',
    selectedDate:"",
  }),
  components:{
    'cancel-icon':cancelIcon,
    "date-picker":DatePicker,
  },
  methods:{
      closeDialog(){
          this.$emit("close")
      },
      calculateDays() {
        const today = new Date(); // Get today's date
        const targetDate = new Date(this.selectedDate); // Convert the target date string to a Date object
        
        const timeDifference = targetDate - today; // Get the difference in milliseconds
        
        // Convert milliseconds to days (1 day = 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
        return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      },
      modifyTTLAction(){
        let invalidPayload = false;
        let postData = (fileInfo) => {
        let payload = {};
        payload._id = fileInfo._id;
        payload.from_context = this.context;
        payload.job_name = "Modify TTL";
        if(this.rangeStrategy == 'by_days'){
          payload.ttl_to_delete = parseInt(this.TTLValue)
          if (payload.ttl_to_delete <= 0){
            invalidPayload = true;
            alert("Please assign a valid number")
            return
          }
        }else{
          let currentDate = new Date().toISOString().split('T')[0]; // Only get the date part
          // Compare the string 'this.selectedDate' directly with the current date string
          if (this.selectedDate > currentDate) {
            payload.ttl_to_delete = this.calculateDays();
          }else if(this.selectedDate == currentDate){
            invalidPayload = true;
            alert("Selected date is equals to today's date.\nPlease select valid date")
            return
          }else {
            invalidPayload = true;
            alert("Selected date is earlier than the current date.\nPlease select valid date")
            return
          }
        }
        payload.size = fileInfo.size;
        payload.resource_name = fileInfo.file_name
        payload.file_type = payload.from_context == "bins"?'file':'asset';
        payload.element_type = 'file';
        this.createNewJob(payload).then((data)=>{
          console.log("[MOdify TTL] Data is : ",data)
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
                if (data.message.includes("Failed")) {
                    this.$toast.warning(data.message);
                } else {
                    this.$toast.success(data.message);
                }
                } else {
                this.$toast.error(data.message);
                }
        });
      }

      if(typeof this.filesInfo != undefined || this.filesInfo.length > 0){
        for(let eachAsset of this.filesInfo){
          postData(eachAsset)
        }
        if(!invalidPayload){
        this.closeDialog();
        }
      }
      },
    ...mapActions("jobs", ["createNewJob"]),
  },
   watch: {
    'show': function (val) {
      if (val) {
          this.$nextTick(() => {
          this.$refs.folderNameField.focus()
        })
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.show = true;
      this.dialog = true;
    }, 200)
  },
  created(){
      if(this.filesInfo.length == 1){
        this.selectedFileInfo = this.filesInfo[0]
        if(this.selectedFileInfo.file_type == "file"){
          if (this.context == "bins"){
            if (this.selectedFileInfo.ttl_to_delete){
              this.TTLValue = this.selectedFileInfo.ttl_to_delete
            }
          }else if (this.context == "catalog"){
            if (this.selectedFileInfo.asset_ttl_to_delete){
              this.TTLValue = this.selectedFileInfo.asset_ttl_to_delete
            }
          }
        }
      }
  }
}
</script>

<style lang="scss" scoped>

  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

  .modal-dialog {
    max-width: 600px;
    width: 600px;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 2rem;
      height:135px;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

.border{
    border: $border-color !important;
}

.modal-header,.modal-footer{
    align-items: center;
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-footer{
  padding:7px !important;
}

.primary-btn-style{
    margin-top:1%;
    button{
        height: 35px;
        width: 70px;
        font-size:14px;
    }
}

.secondary-btn-style{
  color:$text-color;
}

.key-style {
  color: $dull-text-color;
  width: 30%;
  text-align: start;
  font-size: $input-field-and-label-font-size;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  margin-top: 3px;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid $active-blue !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
.config-desc{
  color: $dull-text-color;
  font-size:12px;
}


input[type="radio"] {
  /* background-color only for content */
  background-color:$primary-background !important;
}
  
/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: $active-blue !important;
  background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
  border: $secondary-border-color !important;
}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}
.comm-input-field-style{
    background: $primary-background!important;
    width: 100%;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: 42px;
}

::v-deep{
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:auto;
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar, .mx-icon-clear{
        color:$text-color;
    }
}
</style>